import fp from "lodash/fp";

import { ApplicationStatus } from "models/applicationEntry/status";

const flattenSubStatuses = (statuses?: Array<ApplicationStatus>) => {
	return fp.reduce(
		(options, status) => {
			const mapSubStatuses = subStatuses =>
				subStatuses.map(s => {
					const { name } = status;
					return { ...s, parentStatus: { name } };
				});

			if (!fp.isEmpty(status.subStatuses)) {
				const subStatuses: Array<ApplicationStatus> = fp.flow(
					// orderStatuses,
					mapSubStatuses,
				)(status.subStatuses);

				return [...options, status, ...subStatuses];
			} else {
				return [...options, status];
			}
		},
		[] as Array<ApplicationStatus>,
		statuses,
	);
};

export const mapStatusResponse = fp.flow(flattenSubStatuses);

type Option = {
	name: string;
	id?: number;
	parentStatusId?: number;
	[key: string]: any;
};

export const getFilteredOptions = (
	search: string = "",
	options: Option[] = [],
): Option[] => {
	if (!search) return options;

	const searchLower = search.toLowerCase();

	return options.filter(({ name }) =>
		name.toLowerCase().includes(searchLower),
	);
};

export const getAppStatusFilteredOptions = (
	statuses: Option[],
	search: string,
): Option[] => {
	const filteredOptions = getFilteredOptions(search, statuses);

	const result: Option[] = [];

	filteredOptions.forEach(status => {
		if (status?.parentStatusId) {
			const parentStatus = statuses.find(
				s => s.id === status.parentStatusId,
			);
			if (
				parentStatus &&
				!result.some(
					resultStatus => resultStatus.id === parentStatus.id,
				)
			) {
				result.push(parentStatus);
			}
		}
		result.push(status);
	});

	return result;
};

export const getBusinessUnitFilteredOptions = (
	options: Option[],
	search: string,
): Option[] => {
	const filteredOptions = getFilteredOptions(search, options);

	const result: Option[] = [];

	filteredOptions.forEach(option => {
		if (option.parent) {
			const parent = options.find(p => p?.name === option?.parent?.name);
			if (
				parent &&
				!result.some(
					resultOption => resultOption?.name === parent?.name,
				)
			) {
				result.push(parent);
			}
		}
		result.push(option);
	});

	return result;
};
